/**
 * Следит за незавершённой оплатой: раз в несколько секунд спрашивает сервер, и когда платёж прошёл —
 * выдаёт набор в сохранение. Сервер отдаёт набор один раз, поэтому двойной выдачи не будет.
 */
import type { GameState } from '../core/types';
import { applyPack, packById, type PackDef, type PackResult } from '../core/packs';
import { checkPending, getPending } from './client';

export interface PayWatcher { start(): void; stop(): void; tick(): Promise<void> }

export function createPayWatcher(opts: {
  getState: () => GameState;
  now: () => number;
  petName: (defId: string) => string;
  onGranted: (pack: PackDef, res: PackResult) => void;
  onCanceled?: () => void;
}): PayWatcher {
  let timer: ReturnType<typeof setInterval> | null = null;
  let busy = false;
  const notify = (): void => { window.dispatchEvent(new CustomEvent('pay:update')); };

  async function tick(): Promise<void> {
    if (busy || !getPending()) return;
    busy = true;
    try {
      const st = await checkPending();
      if (typeof st === 'object') {
        const pack = packById(st.packId);
        if (pack) opts.onGranted(pack, applyPack(opts.getState(), pack, opts.now(), opts.petName));
      } else if (st === 'canceled') opts.onCanceled?.();
    } catch { /* сеть/сервер недоступны — повторим на следующем тике */ }
    busy = false;
    notify();
  }
  return {
    start() { if (!timer) { timer = setInterval(() => void tick(), 4000); void tick(); } },
    stop() { if (timer) clearInterval(timer); timer = null; },
    tick,
  };
}
